<script setup lang="ts">
// Atlas wordmark — Mark A + "Atlas" set in mono 700 (machine-truth voice).
// `Atlas` is real text (not an image) so screen readers announce it. Mark
// scales 1.45× the type size to match the brand sheet's proportion.

import AtlasMark from './AtlasMark.vue';

withDefaults(defineProps<{ size?: number; gap?: number }>(), { size: 20, gap: 10 });
</script>

<template>
    <span class="wordmark" :style="{ gap: gap + 'px' }">
        <AtlasMark :size="Math.round(size * 1.45)" />
        <span class="word" :style="{ fontSize: size + 'px' }">Atlas</span>
    </span>
</template>

<style scoped>
.wordmark {
    display: inline-flex;
    align-items: center;
    line-height: 1;
}

.word {
    font-family: var(--font-mono);
    font-weight: 700;
    letter-spacing: -0.5px;
    color: var(--text);
}
</style>
